<template>
  <page-tabs :items="analyticsPageItems" />
</template>

<script setup>
import { computed } from 'vue';
import PageTabs from '@/components/PageTabs.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import State from '@/state/State';

const { tescoPortalStubsEnabled, portalUpdatesJan2026Enabled } = useFeatureFlags();

const analyticsPageItems = computed(() => [
  {
    icon: 'chart-simple',
    name: 'Summary',
    to: 'analytics-homepage',
    visible: true,
  },
  {
    icon: 'mobile-screen-button',
    name: 'App',
    to: 'analytics-app',
    visible: true,
  },
  {
    icon: 'life-ring',
    name: 'Support',
    to: 'analytics-support',
    visible: tescoPortalStubsEnabled.value,
  },
  {
    icon: 'calendar-alt',
    name: 'Shifts',
    to: 'analytics-shifts',
    visible: false,
  },
  {
    icon: 'calendar-days',
    name: 'Bank Pay',
    to: 'analytics-bank-pay',
    visible: State.state.company?.properties?.weekly_pay_settings?.enabled || false,
  },
  {
    icon: 'down-left-and-up-right-to-center',
    name: 'Compare',
    to: 'analytics-compare',
    visible: State.state.claims?.a || (State.state.claims?.m && State.state.divisions?.length > 1) || false,
  },
  {
    icon: 'chart-line',
    name: 'Impact',
    to: 'analytics-benchmark',
    visible: portalUpdatesJan2026Enabled.value,
  },
]);
</script>
